import { money } from "../lib/format";

export function Progress({ miles, goal }: { miles: number; goal: number }) {
  const pct = Math.min(100, Math.round((miles / goal) * 100));
  return (
    <div>
      <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 12, marginBottom: 12 }}>
        <div style={{ fontFamily: "var(--display)", fontSize: 36, fontWeight: 400, color: "var(--ink)", letterSpacing: -1 }}>
          {money(miles).replace("$", "")}
          <span style={{ color: "var(--ink-soft)", fontSize: 18 }}> / {goal.toLocaleString()} mi</span>
        </div>
        <div
          style={{
            background: "var(--accent-tint)",
            color: "var(--accent)",
            padding: "4px 12px",
            borderRadius: 999,
            fontSize: 13,
            fontWeight: 700,
            fontVariantNumeric: "tabular-nums",
          }}
        >
          {pct}%
        </div>
      </div>
      <div style={{ height: 14, borderRadius: 999, background: "var(--line)", overflow: "hidden" }}>
        <div
          style={{
            width: `${pct}%`,
            height: "100%",
            background: "linear-gradient(90deg, var(--accent), var(--accent-soft))",
            transition: "width 1s ease",
          }}
        />
      </div>
    </div>
  );
}
